import { demoFlowFromParam, type DemoFlow } from "@/lib/demoFlows";

/** The demo partner's display name. Read only behind `DEMO_SURFACES_IN_BUILD`. */
export const FEATHER_PARTNER_NAME = "Feather Trust Systems";

/**
 * Review fixture for the Feather Trust Systems walkthrough.
 *
 * The applicant and voucher screens still use the production flow components;
 * this fixture only supplies a safe, tokenless recruiting session for review.
 * Built by a pure function so a production build, which never reads it, drops
 * it (see `DEMO_SURFACES_IN_BUILD`).
 */
function buildFeatherReviewFlow(): DemoFlow {
  const recruitingFlow = demoFlowFromParam("high_volume");
  if (!recruitingFlow) {
    throw new Error(`The ${FEATHER_PARTNER_NAME} review flow requires the high-volume recruiting workflow.`);
  }
  return {
    ...recruitingFlow,
    orgName: FEATHER_PARTNER_NAME,
    steps: recruitingFlow.steps.flatMap((step) =>
      step.step_type === "email"
        ? [step, { step_type: "plaid_idv", required: false }]
        : [step],
    ),
  };
}

export const FEATHER_REVIEW_FLOW: DemoFlow = /*#__PURE__*/ buildFeatherReviewFlow();
